export default {
  locationIssue: {
    alert: {
      title: "Having trouble with finding your location?",
      description:
        "Let us know and we will solve the issue as soon as possible.",
      reportBtn: "Report location issue",
    },
    form: {
      mainTitle: "Report Location Issue",
      title: "Report issue regarding property location",
      description:
        "Please report to us about your location issue and we will get back to you as soon as possible.",
      selectedAddress: "Selected address:",
      issueType: {
        label: "Issue type",
        placeholder: "Select issue",
      },
      state: {
        label: "State",
        placeholder: "Please select",
      },
      city: {
        label: "City",
        placeholder: "eg. Cheras",
      },
      township: {
        label: "Township",
        placeholder: "eg. Seksyen 8",
      },
      address: {
        label: "Street",
        placeholder: "eg. Jalan Permaisuri 3",
      },
      postcode: {
        label: "Postcode",
        placeholder: "eg. 47888",
        message: {
          max: "Postcode must be {max} digits.",
          invalid: "Please enter valid postcode.",
        },
      },
      remarks: {
        label: "Remarks (optional)",
        placeholder: "Please let us know your issue",
        message: {
          max: "A maximum of {max} characters is allowed.",
        },
      },
      cancel: "Cancel",
      submit: "Report issue",
    },
    success: {
      title: "Your issue has been reported",
      sent: "Sent!",
      description:
        "Thank you for submitting your report. Our team will respond to your report within 3 working days.",
      done: "Done",
      backToListings: "Back to create listings page",
    },
    unmappedLocationAlert: {
      title: "Important:",
      description:
        "You won't be able to change the location once you save your changes. Ensure that the address/location entered is accurate.",
      previousAddress: "Previous address: ",
    },
  },
};
